<template>
  <div class="form-number-field">
    <div class="block">
      <input
        type="number"
        class="form-control"
        :disabled="editMode"
        :required="required"
        :placeholder="placeholder"
        v-model="value"
        :min="min"
        :max="max"
        step="any"
        @change="updateValue()"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    editMode: {
      type: Boolean
    },
    model: {
      type: String
    },
    initialValue: {
      type: Number
    },
    required: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  data() {
    return {
      value: 0
    };
  },
  created() {
    if (this.initialValue) {
      this.value = this.initialValue;
    }
  },
  methods: {
    updateValue() {
      if (!this.value) {
        this.value = 0;
      }
      this.$el.parentElement.querySelector(`[id="${this.model}"]`).value = this.value;
      this.$el.parentElement.querySelector(`[id="${this.model}"]`).dispatchEvent(new Event('input'));
    }
  },
  mounted() {
    if (this.$el.parentElement.querySelector(`input[id="${this.model}"]`)) {
      const self = this;
      this.$el.parentElement
        .querySelector(`input[id="${this.model}"]`)
        .addEventListener('change', (newInput) => (self.value = newInput.target.value), false);
      this.updateValue();
    }
  }
};
</script>

<style lang="scss" scoped>
.form-reg-exp-field {
  font-family: 'Talmundo';

  .over-panel {
    position: relative;
    top: -40px;
    width: 100%;
    height: 40px;
    margin-bottom: -40px;
    background-color: transparent;
  }

  .alert-warning {
    display: flex;
    margin-top: 16px;
    flex-direction: row;
    align-items: center;
    font-weight: bold;
    border: solid 1px #856404;
    color: #021c2c;
    i {
      margin-right: 16px;
      color: #856404;
    }
  }
}
</style>
